/* ═══════════════════════════════════════════════════════
   41 SPICE — SHOPIFY THEME JS
═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Nav scroll shadow ──
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('up', window.scrollY > 10);
    }, { passive: true });
  }

  // ── Mobile nav ──
  const ham      = document.getElementById('ham');
  const mobNav   = document.getElementById('mob-nav');
  const mobClose = document.getElementById('mob-close');

  if (ham && mobNav) {
    ham.addEventListener('click', () => mobNav.classList.toggle('open'));
  }
  if (mobClose && mobNav) {
    mobClose.addEventListener('click', () => mobNav.classList.remove('open'));
  }

  // Close mobile nav on link click
  document.querySelectorAll('.mob-link').forEach(link => {
    link.addEventListener('click', () => {
      if (mobNav) mobNav.classList.remove('open');
    });
  });

  // ── FAQ accordion ──
  window.toggleFaq = function(btn) {
    const item = btn.parentElement;
    const wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  };

  // ── Scroll reveal ──
  const revealObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) e.target.classList.add('in');
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -20px 0px' });

  document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

  // Fallback for slow loads
  setTimeout(() => {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('in'));
  }, 1800);

  // ── Reviews carousel ──
  initCarousel();

  // ── Chat widget ──
  const chatWidget = document.getElementById('chatWidget');
  const chatPopup  = document.getElementById('chatPopup');
  if (chatWidget && chatPopup) {
    chatWidget.addEventListener('click', e => {
      e.stopPropagation();
      chatPopup.classList.toggle('open');
    });
    document.addEventListener('click', e => {
      if (!chatWidget.contains(e.target) && !chatPopup.contains(e.target)) {
        chatPopup.classList.remove('open');
      }
    });
  }

  // ── Image fallbacks ──
  document.querySelectorAll('img').forEach(img => {
    const showFallback = () => {
      img.style.display = 'none';
    };
    img.addEventListener('error', showFallback);
    if (img.complete && img.naturalWidth === 0) showFallback();
  });

  // ── Cart AJAX (add to cart without page reload) ──
  document.querySelectorAll('.btn-add-to-cart').forEach(btn => {
    btn.addEventListener('click', function(e) {
      const form = btn.closest('form');
      if (!form) return;
      e.preventDefault();
      btn.textContent = 'Adding…';
      btn.disabled = true;

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(() => {
        btn.textContent = '✓ Added!';
        btn.style.background = 'var(--emerald)';
        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.style.background = '';
          btn.disabled = false;
        }, 2500);
        updateCartCount();
      })
      .catch(() => {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      });
    });
  });

  // ── AJAX pack buttons (homepage pack section) ──
  document.querySelectorAll('.btn-pack[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(() => {
        btn.textContent = '✓ Added!';
        setTimeout(() => {
          btn.textContent = btn.dataset.originalText || 'Choose Pack';
          btn.disabled = false;
        }, 2500);
        updateCartCount();
      })
      .catch(() => {
        btn.textContent = btn.dataset.originalText || 'Choose Pack';
        btn.disabled = false;
      });
    });
  });
});

// ── Cart count update ──
function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const badge = document.querySelector('.v3-cart__count, .cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    });
}

// ── Reviews carousel ──
function initCarousel() {
  const track          = document.getElementById('reviewsTrack');
  const carousel       = document.getElementById('reviewsCarousel');
  const dotsContainer  = document.getElementById('carouselDots');
  const prevBtn        = document.getElementById('prevBtn');
  const nextBtn        = document.getElementById('nextBtn');
  if (!track || !carousel) return;

  const cards = Array.from(track.querySelectorAll('.review-card'));
  let current = 0, startX = 0, isDragging = false, dragOffset = 0;

  function getVisible() {
    const w = carousel.offsetWidth;
    if (w <= 500) return 1;
    if (w <= 800) return 2;
    return 3;
  }

  function getCardWidth() {
    const w   = carousel.offsetWidth;
    const vis = getVisible();
    return Math.floor((w - 18 * (vis - 1)) / vis);
  }

  function applyCardWidths() {
    const cw = getCardWidth();
    cards.forEach(c => {
      c.style.flex  = `0 0 ${cw}px`;
      c.style.width = `${cw}px`;
    });
  }

  function maxIdx() { return Math.max(0, cards.length - getVisible()); }

  function buildDots() {
    dotsContainer.innerHTML = '';
    const pages = maxIdx() + 1;
    for (let i = 0; i < pages; i++) {
      const d = document.createElement('button');
      d.className = 'carousel-dot' + (i === current ? ' active' : '');
      d.setAttribute('aria-label', `Go to slide ${i + 1}`);
      d.onclick = () => goTo(i);
      dotsContainer.appendChild(d);
    }
  }

  function goTo(idx) {
    current = Math.max(0, Math.min(idx, maxIdx()));
    const cw     = getCardWidth();
    const offset = current * (cw + 18);
    track.style.transform = `translateX(-${offset}px)`;
    dotsContainer.querySelectorAll('.carousel-dot').forEach((d, i) =>
      d.classList.toggle('active', i === current)
    );
  }

  if (prevBtn) prevBtn.onclick = () => goTo(current - 1);
  if (nextBtn) nextBtn.onclick = () => goTo(current + 1);

  // Touch / drag
  carousel.addEventListener('mousedown', e => {
    isDragging = true; startX = e.pageX;
    track.style.transition = 'none';
  });
  carousel.addEventListener('touchstart', e => {
    isDragging = true; startX = e.touches[0].pageX;
    track.style.transition = 'none';
  }, { passive: true });

  carousel.addEventListener('mousemove', e => {
    if (!isDragging) return;
    dragOffset = e.pageX - startX;
    const cw = getCardWidth();
    track.style.transform = `translateX(${-(current * (cw + 18)) + dragOffset}px)`;
  });
  carousel.addEventListener('touchmove', e => {
    if (!isDragging) return;
    dragOffset = e.touches[0].pageX - startX;
    const cw = getCardWidth();
    track.style.transform = `translateX(${-(current * (cw + 18)) + dragOffset}px)`;
  }, { passive: true });

  function endDrag() {
    if (!isDragging) return;
    isDragging = false;
    track.style.transition = '';
    if (dragOffset < -50)       goTo(current + 1);
    else if (dragOffset > 50)   goTo(current - 1);
    else                        goTo(current);
    dragOffset = 0;
  }
  carousel.addEventListener('mouseup', endDrag);
  carousel.addEventListener('mouseleave', endDrag);
  carousel.addEventListener('touchend', endDrag);

  window.addEventListener('resize', () => {
    applyCardWidths();
    buildDots();
    goTo(Math.min(current, maxIdx()));
  });

  applyCardWidths();
  buildDots();
  goTo(0);
}
